import React, { useState, useEffect, useContext } from 'react';

const AppSectionConfig = () => {
  return <div>world</div>;
};

export default AppSectionConfig;
